// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of } from 'rxjs';

// --- 3rd Party
import { isUndefined } from 'lodash';

// --- HS Code
import { SurveyBaseService } from './survey-base.service';
import {
  SortDirections,
  SurveyModel,
  SurveyStatuses,
  SurveySummaryModel,
  ResultsStatuses,
  SurveyIdentifiersModel,
} from '../../../models';
import { AppService } from '../app.service';
import { ParticipantGroupsBaseService } from '..';
import { RespondentsBaseService } from './respondents-base.service';
import { ResponseBaseService } from './response-base.service';
import { ResultsBaseService } from '../results/results-base.service';
import { UserNotificationBaseService } from '../notifications/user-notification-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class SurveyMockService extends SurveyBaseService {
  override getSurveySummary(id: string): void {
    throw new Error('Method not implemented.');
  }
  private surveys: SurveyModel[];

  constructor(
    appService: AppService,
    notificationService: UserNotificationBaseService,
    participantGroupsService: ParticipantGroupsBaseService,
    respondentsService: RespondentsBaseService,
    responseService: ResponseBaseService,
    resultsService: ResultsBaseService
  ) {
    super(
      participantGroupsService,
      appService,
      responseService,
      resultsService,
      notificationService,
      respondentsService
    );
    this.surveys = new Array<SurveyModel>();
  }

  loadSummaries(
    pageSize: number,
    pageNumber: number,
    filter: string,
    sortItem: string,
    sortDirection: SortDirections
  ): void {
    if (filter) {
      this._selfSurveys$.next(new Array<SurveySummaryModel>());
    } else {
      const mySurveys = [
        {
          dateCreated: new Date(),
          id: '1',
          moniker: 'HSS1',
          name: '',
          dateOfReportRelease: new Date(),
          percentageComplete: 0,
          status: SurveyStatuses.notStarted,
        } as SurveySummaryModel,
        {
          dateCreated: new Date(),
          id: '2',
          moniker: 'HSS2',
          name: 'The completed one',
          dateOfReportRelease: new Date(),
          percentageComplete: 100,
          status: SurveyStatuses.completeSurvey,
        } as SurveySummaryModel,
        {
          dateCreated: new Date(),
          id: '3',
          moniker: 'HSS3',
          name: 'The incompleted one',
          dateOfReportRelease: new Date(),
          percentageComplete: 35,
          status: SurveyStatuses.indicatorQuestions,
        } as SurveySummaryModel,
        {
          dateCreated: new Date(),
          id: '4',
          moniker: 'HSS4',
          name: 'Complete Payment Pending',
          dateOfReportRelease: new Date(),
          percentageComplete: 45,
          status: SurveyStatuses.completeSurvey,
          resultsStatus: ResultsStatuses.pendingPayment,
        } as SurveySummaryModel,
        {
          dateCreated: new Date(),
          id: '5',
          moniker: 'HSS5',
          name: 'Complete Results Pending',
          dateOfReportRelease: new Date(),
          organisationName: 'Organisation Name 5',
          percentageComplete: 45,
          status: SurveyStatuses.completeSurvey,
          resultsStatus: ResultsStatuses.pendingReportReleaseDate,
        } as SurveySummaryModel,
      ];

      this._selfSurveys$.next(mySurveys);
      this._selectedSelfSurvey$.next(mySurveys[0]);
    }
  }

  loadSurveyById(id: string): void {
    const exists = this.surveys.find((s) => {
      return s.moniker === id || s.id === id;
    });

    if (exists) {
      this._activeSurvey$.next(exists);
    }

    const survey = {} as SurveyModel;
    const newDate = new Date();
    survey.dateCreated = newDate;
    survey.dateLastUpdated = newDate;
    survey.id = 's1';
    survey.moniker = 'survey1';

    this._currentSurveyIdentifiers$.next({
      surveyId: '1',
      participantId: '1',
      surveyReference: 'HSS1'
    } as SurveyIdentifiersModel);

    this._activeSurvey$.next(survey);
  }

  override getMostRecentParticipantSurvey(ignoreSavedSelectedSurvey: boolean = false): void {
    this._mostRecentSurvey = {
      surveyId: '1',
      participantId: '1',
      surveyReference: 'HSS1'
    } as SurveyIdentifiersModel;

    this._currentSurveyIdentifiers$.next(this._mostRecentSurvey);
  }

  override mostRecentParticipantSurvey(): Observable<SurveyIdentifiersModel | null> {
    if (!isUndefined(this._mostRecentSurvey)) return of(this._mostRecentSurvey);

  this.getMostRecentParticipantSurvey();
    return this.currentSurveyIdentifiers$;
  }
}
